"use client";

import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

import {
  getPublicPlatformSettings,
  getPublicPlatformSettingsFallback,
  type PublicPlatformSettings,
} from "@/lib/public-platform-settings";

export default function FloatingWhatsApp() {
  const [settings, setSettings] =
    useState<PublicPlatformSettings>(
      getPublicPlatformSettingsFallback(),
    );

  useEffect(() => {
    let active = true;

    void getPublicPlatformSettings().then(
      (response) => {
        if (active) {
          setSettings(response);
        }
      },
    );

    return () => {
      active = false;
    };
  }, []);

  if (!settings.support_whatsapp) {
    return null;
  }

  const whatsappUrl =
    `https://wa.me/${settings.support_whatsapp}` +
    `?text=${encodeURIComponent(
      settings.whatsapp_message,
    )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Precisa de ajuda? Fale com o ${settings.platform_name} pelo WhatsApp`}
      title="Fale conosco pelo WhatsApp"
      className="
        fixed bottom-5 right-5 z-40
         group inline-flex items-center overflow-hidden
        rounded-lg
        bg-green-600
        p-3
        text-white
        shadow-lg
        transition-all duration-200
        hover:-translate-y-0.5
        hover:bg-green-700
        hover:shadow-xl
        focus:outline-none
        focus-visible:ring-2
        focus-visible:ring-green-500
        focus-visible:ring-offset-2
        sm:bottom-6 sm:right-6
      "
    >
      <FaWhatsapp
        className="h-8 w-8 shrink-0"
        aria-hidden="true"
      />

      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold leading-tight opacity-0 transition-all duration-300 md:group-hover:ml-3 md:group-hover:max-w-[150px] md:group-hover:opacity-100 md:group-focus-within:ml-3 md:group-focus-within:max-w-[150px] md:group-focus-within:opacity-100">
        Precisa de
        <br />
        ajuda?
      </span>
    </a>
  );
}
